<template>
  <div id="app">
    <header class="header sticky-top py-2">
      <div class="container">
        <app-progress class="mb-2"></app-progress>
      </div>
    </header>
    <div class="header mt-0 py-2">
      <img
        class="mx-auto d-block my-2"
        height="80"
        style="filter: invert(1)"
        src="@/assets/Real-Ireland-logo[Mono].png"
      />
      <h2 class="text-center">{{ title }}</h2>
    </div>
    <div class="container py-4">
      <div class="row">
        <div class="col">
          <transition name="slide" mode="out-in">
            <component :is="wizardComponent"> </component>
          </transition>
        </div>
      </div>
      <div v-if="debugMode" class="row my-4 justify-content-end">
        <button class="btn btn-info mx-1" @click="prevStep">Previous</button>
        <button
          class="btn btn-success mx-1"
          @click="nextStep"
          :disabled="!canNext"
        >
          Next
        </button>
      </div>
    </div>
    <footer class="pt-2 pb-2 footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <p>
              Copyright © {{ new Date().getFullYear() }} Luxury European Tours
              Ltd.<br />
              All rights reserved<br />
            </p>
          </div>
          <div class="col-md-6">
            <span>
              <font-awesome-icon icon="envelope" />&nbsp;<a :href="mailTo"
                >Email Luxury European Tours Ltd</a
              > </span
            ><br />
            <span>
              <font-awesome-icon icon="phone-alt" />&nbsp;<a :href="tel"
                >Call Luxury European Tours Ltd</a
              > </span
            ><br />
            <span>
              <font-awesome-icon icon="globe-europe" />&nbsp;<a
                href="https://www.luxuryeuropeantours.com"
                >Visit luxuryeuropeantours.com</a
              >
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col d-flex justify-content-end">
            <span>
              <font-awesome-icon icon="envelope" />&nbsp;
              <a href="mailto:info@portseasoftware.com"
                >Website by Portsea Software Ltd</a
              >
            </span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import appProgress from './components/Progress.vue'
import appError from './components/wizard/00_Error.vue'
import appStart from './components/wizard/01_Start.vue'
import appTransfers from './components/wizard/02_Transfers.vue'
import appDayByDay from './components/wizard/03_DayByDay.vue'
import appRooming from './components/wizard/04_Rooming.vue'
import appPassengers from './components/wizard/05_Passengers.vue'
import appSummary from './components/wizard/06_Summary.vue'
import appPayment from './components/wizard/07_Payment.vue'
import appThankyou from './components/wizard/08_Thankyou.vue'

export default {
  name: 'App',
  computed: {
    ...mapState({ initialised: state => state.static.initialised }),
    ...mapGetters(['wizardComponent', 'canNext', 'canPrev']),
    debugMode() {
      return process.env.VUE_APP_DEBUG == 'true'
    },
    title() {
      return process.env.VUE_APP_TITLE
    },
    mailTo() {
      return `mailto:${process.env.VUE_APP_CONTACT_EMAIL}`
    },
    tel() {
      return `tel:${process.env.VUE_APP_CONTACT_PHONE}`
    }
  },
  methods: {
    ...mapActions(['nextStep', 'prevStep'])
  },
  components: {
    appProgress,
    appError,
    appStart,
    appDayByDay,
    appTransfers,
    appPassengers,
    appRooming,
    appSummary,
    appPayment,
    appThankyou
  }
}
</script>
